import sharedGlobal from '../sharedglobals'

export default function request(options) {
    if (options.params) {
        if (options.url.indexOf('?') >= 0) {
            options.url += '&'
        } else {
            options.url += '?'
        }
        // eslint-disable-next-line no-undef
        options.url += $.param(options.params);
    }
    if (!options.contentType) {
        options.contentType = 'application/json';
    }
    let dataType = '';
    if (options.contentType == 'application/json'&&options.dataType) {
        dataType = 'json'
    }
    if(options.dataType===null){
        dataType=undefined;
    }

    let xhrFields = {};
    if (options.withCredentials) {
        xhrFields.withCredentials = true;
    }
    return new Promise((resolve, reject) => {
        // eslint-disable-next-line no-undef
        $.ajax({
            url: options.url,
            contentType: options.contentType,
            method: options.method,
            dataType: dataType,
            data: JSON.stringify(options.data),
            headers: {
                "Authorization": "Bearer " + sharedGlobal.sessionToken,
            },
            xhrFields
        }).done((resp, textStatus, jqXHR) => {
            if (options.returnDetailed === true) {
                let headers = {};
                let headerTexts = jqXHR.getAllResponseHeaders().split("\r\n");
                headerTexts.forEach(function (header) {
                    header = header.split(": ");
                    var key = header.shift();
                    if (key.length == 0) return
                    // chrome60+ force lowercase, other browsers can be different
                    key = key.toLowerCase();
                    headers[key] = header.join(": ");
                });
                resolve({ response: resp, headers })
            } else {
                resolve(resp);
            }
        }).fail(resp => {
            reject(resp);
        });
    });
}

export function uploadFile(file) {
    return new Promise((resolve, reject) => {
        let url = sharedGlobal.appUrls.insSharedApiUrl + 'api/InsShared/UploadDocument?fileName='+encodeURIComponent(file.name);
        let formData = new FormData();
        formData.append("file", file);
        // eslint-disable-next-line no-undef
        $.ajax({
            url: url,            
            contentType: false,
            processData: false,
            data: formData,
            type: 'POST',
            crossDomain: true,
            headers: {
                "Authorization": "Bearer " + sharedGlobal.sessionToken,
            }

        }).then(function (sr, status, xhr) {
            resolve(sr);            
        }).fail(resp => {
            reject(resp);
        })
})
} 

export function bulkFileUpload(file) {
    return new Promise((resolve, reject) => {
        let url = sharedGlobal.appUrls.insSharedApiUrl + 'api/Policy/BulkPhotoUpload?fileName='+encodeURIComponent(file.name);
        let formData = new FormData();
        formData.append("file", file);
        // eslint-disable-next-line no-undef
        $.ajax({
            url: url,            
            contentType: false,
            processData: false,
            data: formData,
            type: 'POST',
            crossDomain: true,
            headers: {
                "Authorization": "Bearer " + sharedGlobal.sessionToken,
            }

        }).then(function (sr, status, xhr) {
            resolve(sr);            
        }).fail(resp => {
            reject(resp);
        })
})
}
export function downloadBlob(options) {
    if (options.params) {
        if (options.url.indexOf('?') >= 0) {
            options.url += '&'
        } else {
            options.url += '?'
        }
        // eslint-disable-next-line no-undef
        options.url += $.param(options.params);
    }   
    let ajaxOptions={
        url: options.url,
        cache:false,
        type: 'POST',
        //contentType: options.contentType,
     // dataType: dataType,
       // data: JSON.stringify(options.data),
        xhr:function(){// Seems like the only way to get access to the xhr object
            var xhr = new XMLHttpRequest();
            xhr.responseType= 'blob'
            return xhr;
        },
        headers: {
            "Authorization": "Bearer " + sharedGlobal.sessionToken,
        }            
    };
    if(options.data){
        ajaxOptions.contentType = 'application/json';
        ajaxOptions.data=JSON.stringify(options.data);
    }
    return new Promise((resolve, reject) => {
        // eslint-disable-next-line no-undef
        $.ajax(ajaxOptions).done((resp, textStatus, jqXHR) => {          
                saveBlobAs(resp,options.saveAsFileName);                           
                resolve(1);            
        }).fail(resp => {
            reject(resp);
        });
    });
}
function saveBlobAs(content, fileName) {
    const a = document.createElement("a");    
    let url = window.URL.createObjectURL(content);    
    a.href = url;
    a.download = fileName;
    a.click();  
    window.URL.revokeObjectURL(url);    
  } 
    export function ManualUploadFile(file, fileType,subFolder) {
    return new Promise((resolve, reject) => {
        let url = sharedGlobal.appUrls.insSharedApiUrl + 'api/InsShared/UploadDocumentsToStorage?fileName='+encodeURIComponent(file.name)+'&&fileType='+fileType +'&&subFolder=' +subFolder;
        let formData = new FormData();
        formData.append("file", file);
        // eslint-disable-next-line no-undef
        $.ajax({
            url: url,            
            contentType: false,
            processData: false,
            data: formData,
            type: 'POST',
            crossDomain: true,
            headers: {
                "Authorization": "Bearer " + sharedGlobal.sessionToken,
            }

        }).then(function (sr, status, xhr) {
            resolve(sr);            
        }).fail(resp => {
            reject(resp);
        })
})
    }